<template>
  <div class="box">
    <img class="user_title" src="@/assets/img/insu_detail/user_title.png" alt="" />
    <div class="renewal-css">
      <p>2021年购买湖南爱民保客户</p>
      <img src="@/assets/img/insu_detail/oneKey.png" alt="一键续保" @click="handleGoBuy" />
    </div>
    <div class="header">
      <span class="num">1</span>
      <span class="title">本人信息</span>
      <span class="subtitle">(缴费人)</span>
    </div>
    <van-form class="form" :validate-first="true" ref="appntForm" :scroll-to-error="true">
      <van-field v-model="formData.appntName" label="姓名" name="appntName" clearable placeholder="请输入真实姓名"
        :rules="formRules.appntNameR" :readonly="xfzIndex === 0" spellcheck="false" maxlength="30"
        id="Name_Of_Purchaser" @click-input="getXfz" @focus="clearValidate('appntName', 'appntForm')"
        @blur="updateSelf" />
      <van-field>
        <div slot="label" class="flex" @click="getType()">
          <span class="filed-label">{{ formData.idName }}</span>
          <van-icon name="arrow-down" />
        </div>
        <template #input>
          <van-field class="userCardNo" id="IDcard_Of_Purchaser" type="text" clearable v-model="formData.appntIdNo"
            placeholder="请输入证件号" maxlength="30" :readonly="xfzIndex === 0" :rules="formRules.appntCardNoR"
            @click-input="getXfz" spellcheck="false" name="appntIdNo" @focus="clearValidate('appntIdNo', 'appntForm')"
            @blur="updateSelf" />
        </template>
      </van-field>
      <van-field v-model="formData.appntMobileNumber" id="Login_Mobile" center clearable label="登录手机号"
        placeholder="用于后续账号登录" :readonly="xfzIndex === 0" :rules="formRules.appntMobileNumber" @click-input="getXfz"
        name="appntMobileNumber" @focus="clearValidate('appntMobileNumber', 'appntForm')" @blur="updateSelf">
      </van-field>
      <van-field name="radio" label="性别" v-if="formData.idName !== '身份证'" :rules="formRules.appntSexR">
        <template #input>
          <van-radio-group v-model="formData.userSex" @change="updateSelf" direction="horizontal">
            <van-radio name="0">男</van-radio>
            <van-radio name="1">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-if="formData.idName !== '身份证'" readonly clickable name="picker" :value="formData.userBirthday"
        :rules="formRules.userBirthday" label="出生日期" placeholder="点击出生日期" @click="clickBirthday('', '')"
        @focus="clearValidate('picker', 'appntForm')" />
    </van-form>
    <div class="header">
      <span class="num">2</span>
      <span class="title">为谁参保</span>
      <span class="subtitle">(被保人)</span>
    </div>
    <div class="card">
      <van-form ref="userForm" class="userForm" v-for="(item, index) in userInfo" :key="index" :validate-first="true">
        <div class="part-title">
          <div>参保人{{ index + 1 }}</div>
          <div v-if="userInfo.length > 1" type="default" size="small" native-type="button" class="btn-delete"
            @click="deleteInsured(index)" style="font-weight: normal;">
            删除
          </div>
        </div>
        <van-field v-model="item.insuredRelation" name="insuredRelation"
          :rules="[{ required: true, message: '请选择人员关系' }]">
          <template #input>
            <div class="relationships">
              <div v-for="(relation, rIndex) in insuredRelationList" :key="rIndex" :id="relation.id"
                :class="{ active: item.insuredRelation === relation.value }" @click="getActive(relation.value, index)">
                {{ relation.title }}
                <img src="@/assets/img/insu_detail/active.png" v-show="item.insuredRelation === relation.value" />
              </div>
            </div>
          </template>
        </van-field>
        <van-field id="Insured_Name" v-model="item.userName" label="姓名" clearable placeholder="请输入真实姓名"
          :disabled="item.insuredRelation === 'oneself'" :rules="formRules.userNameR" spellcheck="false" name="userName"
          @focus="clearValidate('userName', 'userForm', index)" />
        <van-field :disabled="item.insuredRelation === 'oneself'">
          <div slot="label" class="flex" @click="getTypeShow(index)">
            <span class="filed-label">{{ item.idName }}</span>
            <van-icon name="arrow-down" />
          </div>
          <template #input>
            <van-field class="userCardNo" v-model="item.userCardNo" placeholder="请输入证件号" id="Insured_IDcard" type="text"
              clearable maxlength="30" :disabled="item.insuredRelation === 'oneself'" :rules="formRules.userCardNoR"
              spellcheck="false" name="userCardNo" @focus="clearValidate('userCardNo', 'userForm', index)" />
          </template>
        </van-field>
        <van-field name="radio" label="性别" v-if="item.idName !== '身份证'" :disabled="item.insuredRelation === 'oneself'"
          :rules="formRules.userSexR">
          <template #input>
            <van-radio-group v-model="item.userSex" direction="horizontal"
              :disabled="item.insuredRelation === 'oneself'">
              <van-radio name="0">男</van-radio>
              <van-radio name="1">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="item.idName !== '身份证'" readonly clickable name="picker" :value="item.userBirthday" label="出生日期"
          placeholder="点击出生日期" @click="clickBirthday2(index)" :disabled="item.insuredRelation === 'oneself'"
          :rules="formRules.userBirthday" />
        <!-- <van-field
          v-model="item.credentialValidPeriodText"
          readonly
          name="picker"
          placeholder="选择有效期"
          label="证件有效期"
          :rules="formRules.credentialValidPeriod"
          @click="openValidity(index)"
        ></van-field>
        <div class="startEndDate">
          <span class="title">证件起止日期</span>
          <van-field
            v-model="item.credentialValidStartDate"
            placeholder="选择证件起期"
            input-align="center"
            readonly
            name="picker"
            @click="clickIDTime(index, 'credentialValidStartDate')"
            :rules="formRules.credentialValidStartDate"
          ></van-field>
          <span>-</span>
          <van-field
            v-model="item.credentialValidExpireDate"
            readonly
            name="picker"
            @click="clickIDTime(index, 'credentialValidExpireDate')"
            placeholder="选择证件止期"
            input-align="center"
            :rules="formRules.credentialValidExpireDate"
          ></van-field>
        </div> -->

        <van-field id="Insured_Place" label="医保所属地" name="picker" clearable v-model="item.address" readonly
          placeholder="请选择医保所属地" @click="openCanbaodi(item.address, index)" :rules="formRules.userCanBaodi" />
        <van-field label="" v-if="item.insuredRelation == 'other'">
          <template #input>
            <div :style="{ color: '#FF644A' }">
              尊敬的客户，您可为其他具有可保利益的人员投保。
            </div>
          </template>
        </van-field>
      </van-form>
    </div>
    <!-- 添加被保人 -->
    <div class="add" @click="addInfo">
      <img id="Add_Insured" :src="cdnresources + '/prod/images/xiangaibao/addbtn.png'" />
    </div>
    <div class="header" v-if="showAdvancePayment">
      <span class="num">3</span>
      <span class="title">延续保障服务提醒</span>
      <!-- <span class="subtitle">(如需开通请在支付前点选)</span> -->
    </div>
    <div id="isAdvancePayment" class="radio_style" v-if="showAdvancePayment">
      <div class="radio_tabs">
        <div @click="ckradio('20')" :class="formData.isAdvancePayment == '20' ? 'active' : 'noactive'">
          <span>不开通</span>
          <img src="@/assets/img/insu_detail/dui.png" v-if="formData.isAdvancePayment == '20'" />
        </div>
        <div @click="ckradio('10')" :class="formData.isAdvancePayment == '10' ? 'active' : 'noactive'">
          <span>开通</span>
          <img src="@/assets/img/insu_detail/dui.png" v-if="formData.isAdvancePayment == '10'" />
          <img class="ckTip" src="@/assets/img/insu_detail/ckTip.png" alt="" />
        </div>
      </div>
      <!-- <p>
        湖南爱民保次年保障方案与收费标准可能会因政策因素进行调整，最终以相关部门发文通知为准
      </p> -->
    </div>
    <!-- <div class="open_detail">
      <div class="first_kt" v-if="formData.isAdvancePayment == 20">
        <img src="@/assets/img/insu_detail/no.png" />
        <div class="openList">
          <div class="open_title">不开通，一旦断保将面临：</div>
          <div class="open_con">失去高额保障，不能理赔</div>
        </div>
      </div>
      <div class="first_kt" v-else>
        <img src="@/assets/img/insu_detail/open.png" />
        <div class="openList">
          <div class="open_title">开通可享受：</div>
          <div class="open_con">
            次年自动按最新费率申请投保；<br />
            随时可取消，无额外费用
          </div>
        </div>
      </div>
      <div class="open-xy">
        开通前请仔细阅读<span @click="clickAuto">《自动投保服务协议》</span>
      </div>
    </div> -->
    <!-- 证件类型 -->
    <van-overlay :show="show">
      <div class="select-type" v-if="show">
        <van-picker title="证件类型" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="show = false" />
      </div>
    </van-overlay>
    <!-- 证件类型 -->
    <van-overlay :show="typeShow">
      <div class="select-type" v-if="typeShow">
        <van-picker title="证件类型" show-toolbar :columns="columns" @confirm="onConfirm2" @cancel="typeShow = false" />
      </div>
    </van-overlay>
    <van-overlay :show="showBirthdayFlag">
      <div class="select-type" v-if="showBirthdayFlag">
        <van-datetime-picker type="date" title="选择年月日" v-model="currentDate" :min-date="minDate" :max-date="maxDate"
          @confirm="onConfirmBirthday" @cancel="showBirthdayFlag = false" />
      </div>
    </van-overlay>
    <van-overlay :show="showBirthdayFlag2">
      <div class="select-type" v-if="showBirthdayFlag2">
        <van-datetime-picker type="date" title="选择年月日" v-model="currentDate2" :min-date="minDate" :max-date="maxDate"
          @confirm="onConfirmBirthday2" @cancel="showBirthdayFlag2 = false" />
      </div>
    </van-overlay>
    <van-overlay :show="showIDTime">
      <div class="select-type" v-if="showIDTime">
        <van-datetime-picker type="date" title="选择年月日" v-model="currentDate2" :min-date="minDates" :max-date="maxDates"
          @confirm="confirmIDTime" @cancel="showIDTime = false" />
      </div>
    </van-overlay>
    <van-overlay :show="showValidity">
      <div class="select-type" v-if="showValidity">
        <van-picker title="有效期" show-toolbar :columns="validityColumns" @confirm="validityConfirm"
          @cancel="showValidity = false" />
      </div>
    </van-overlay>
    <!-- 医保所属地列表 -->
    <van-action-sheet v-model="showCanBaodi" :close-on-click-overlay="false" style="height:auto">
      <div class="content">
        <div class="title">
          <img src="@/assets/img/insu_detail/title-left.png" />
          <span>选择医保所属地</span>
          <img src="@/assets/img/insu_detail/title-right.png" />
        </div>
        <div class="sub-title">请先选择医保所属地</div>
        <div class="city-list">
          <div class="city-item" :class="[index == activeIndex && 'city-item-acitve']" v-for="(item, index) in cityList"
            :key="index" @click="handleSelectCity(item, index)">
            {{ item.cityName }}
          </div>
        </div>
        <div class="btn btn-canbaodi">
          <van-button class="button" round type="primary" size="large"
            color="linear-gradient(to right, #ffaf40,#ff7108)" @click="handleSureCity">确定</van-button>
        </div>
      </div>
    </van-action-sheet>

    <!-- 消费者保障服务 -->
    <van-action-sheet v-model="xfzShow" :close-on-click-overlay="false" style="height:auto;">
      <div class="content">
        <div class="title">
          <img src="@/assets/img/insu_detail/title-left.png" />
          <span>消费者权益保障服务</span>
          <img src="@/assets/img/insu_detail/title-right.png" />
        </div>
        <div class="fasongya_text">
          <p>
            中国人寿保险股份有限公司湖南省分公司主承保，中国太平洋财产保险股份有限公司湖南分公司副主承保，中国人寿财产保险股份有限公司湖南省分公司、中国平安财产保险股份有限公司湖南分公司、新华人寿保险股份有限公司湖南分公司、中国太平洋人寿保险股份有限公司湖南分公司、财信吉祥人寿保险股份有限公司湖南分公司、中国大地财产保险股份有限公司湖南分公司、中国人民健康保险股份有限公司湖南分公司、太平财产保险有限公司湖南分公司、阳光人寿保险股份有限公司湖南分公司、阳光财产保险股份有限公司湖南省分公司、平安健康保险股份有限公司湖南分公司、长安责任保险股份有限公司湖南省分公司共同承保。
          </p>
          <p>
            请仔细阅读<span @click="showNote = true">《重要说明》</span>等内容，为保障您的权益，您在销售页面的操作将被记录并加密存储。
          </p>
        </div>
        <div class="btn">
          <van-button class="button" round type="primary" size="large"
            color="linear-gradient(to right, #ffaf40,#ff7108)" @click="xfzShow = false">我已知晓</van-button>
        </div>
      </div>
    </van-action-sheet>
    <!-- 一键续保查询历史数据验证码 -->
    <van-dialog class="perDialog" width="80%" v-model="showCode" :showConfirmButton="false" title="一键获取历史投保人信息">
      <div class="form-content">
        <van-field class="field-input" label="手机号" placeholder="请输入手机号码" v-model.trim="historyForm.mobilePhone"
          @blur="checkPhone" :error-message="errMsg.mobilePhone" clearable />
        <van-field class="field-input" label="验证码" placeholder="请输入验证码" v-model.trim="historyForm.captcha" clearable
          maxlength="6" :error-message="errMsg.captcha" @blur="checkVeriCode" style="padding-right:0;">
          <template #button>
            <SendCaptcha :phone="historyForm.mobilePhone" />
          </template>
        </van-field>
      </div>
      <div class="perBtngroup">
        <van-button size="small" round @click="handleBuy(1)" class="cancel">取消</van-button>
        <van-button size="small" round @click="handleBuy(2)" :loading="loadingBuy" loading-text="确认中..."
          :disabled="sureDisabled">确认</van-button>
      </div>
    </van-dialog>
    <van-dialog class="perDialog" width="80%" v-model="showError" :showConfirmButton="false">
      <div class="not-yet">
        <img src="@/assets/img/insu_detail/not.png" alt="" />
      </div>
      <p>暂未查询到您的历史订单</p>
      <div class="perBtn">
        <van-button size="small" round @click="handleBuy(3)">返回到投保页</van-button>
      </div>
    </van-dialog>
    <pdf-action-sheet v-model="showzhuchexieyi" :style-obj="{ height: '70%' }" title="用户协议">
      <RegisterProtocol />
    </pdf-action-sheet>

    <pdf-action-sheet v-model="showyisixiey" :style-obj="{ height: '70%' }" title="隐私声明">
      <PrivacyStatement />
    </pdf-action-sheet>
    <pdf-action-sheet v-model="showNote" :style-obj="{ height: '70%' }" title="重要说明">
      <ImportantNote />
    </pdf-action-sheet>
    <pdf-action-sheet v-model="showZdtbxy" :style-obj="{ height: '70%' }" title="自动投保服务协议">
      <div class="contentstyle" v-html="contenthtml" v-if="showZdtbxy"></div>
      <div class="testWrap">
        <van-button round block @click="showZdtbxy = false" id="Agree_Terms" class="autoBtn">确认接受</van-button>
      </div>
    </pdf-action-sheet>
  </div>
</template>
<script>
import { cdnresources } from '@/util/config'
import ImportantNote from '@/views/PdfFiles/ImportantNote'
import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
import RegisterProtocol from '@/views/UserSection/RegisterProtocol'
import PrivacyStatement from '@/views/UserSection/PrivacyStatement'
import dayjs from 'dayjs'
import { CHECK_ID, CHECK_MOBILE_PHONE, deepCopy } from '@/util/validate'
import {
  HalfFullWidithCharactor,
  CnNameValidate
} from '@/util/insu-validate.js'
import {
  GET_GENDER_FROM_ID,
  GET_BIRTHDAY_FROM_ID,
  getDeviceInfo,
  setCompareRegistrationTimeText
} from '@/util/tools' // GetAge
import { checkSpouseGender } from '@/util/insuCheck'
import { getCities } from '@/api/insu-info'
import {
  findUserInfo,
  getCustomerInfo,
  FindUserInsuranceDetail,
  getALIInfo,
  FindUserRenewalInsure
} from '@/api/user'
import { Toast } from 'vant'
import { axiosclause } from '@/api/company-appointment'
import { SetGetAuthInfo, AppCode } from '@/util/auth'
import AES from '@/util/AES'
import { gethttpurl } from '@/util/tools'
import SendCaptcha from '@/components/SendCaptcha'

// import { mapState } from 'vuex'
export default {
  components: {
    RegisterProtocol,
    PrivacyStatement,
    PdfActionSheet,
    ImportantNote,
    SendCaptcha
  },
  data() {
    return {
      renewalShow: true,
      sureDisabled: false,
      showError: false,
      loadingBuy: false,
      historyForm: {
        mobilePhone: '',
        captcha: ''
      },
      errMsg: {
        mobilePhone: '',
        captcha: ''
      },
      showCode: false,
      cdnresources,
      showPicker: false,
      showCanBaodi: false,
      insufoChecked: false,
      showzhuchexieyi: false,
      showyisixiey: false,
      showNote: false,
      xfzIndex: 0,
      xfzShow: false,
      showKeyboard: false,
      minDate: new Date('1900/01/01'),
      maxDate: new Date(),
      minDates: new Date('1900/01/01'),
      maxDates: new Date('2299/12/31'),
      currentDate: new Date('1990/01/01'),
      currentDate2: new Date('1990/01/01'),
      showBirthdayFlag: false,
      showBirthdayFlag2: false,
      show: false,
      typeShow: false,
      idName: '身份证',
      veriTipText: '获取验证码',
      mobilePhone: '',
      columns: [
        { type: 'identityCard', text: '身份证' },
        { type: 'HongKongMacaoAndTaiwanPass', text: '港澳台同胞证' },
        // { type: 'officerCard', text: '军官证' },
        { type: 'passport', text: '护照' }
      ],
      insuredRelationList: [
        { title: '本人', value: 'oneself', id: 'Insured_Himself' },
        { title: '配偶', value: 'spouse', id: 'Insured_Spouse' },
        { title: '父母', value: 'parent', id: 'Insured_Parent' },
        { title: '子女', value: 'children', id: 'Insured_Child' },
        { title: '其他', value: 'other', id: 'Insured_Other' }
      ],
      showAdvancePayment: true,
      formData: {
        appntName: '',
        appntIdNo: '',
        appntIdType: 'identityCard',
        idName: '身份证',
        appntMobileNumber: '',
        captcha: '',
        insuredRelation: '',
        personnelType: 'policyHolder',
        userSex: '',
        userBirthday: '',
        isAdvancePayment: '10'
      },
      userInfo: [],
      formObj: {
        isAdvancePayment: 0,
        userName: '',
        userMobile: '',
        idName: '身份证',
        userCardType: 'identityCard',
        userCardNo: '',
        insuredRelation: '',
        personnelType: 'insured',
        userBirthday: '',
        userSex: '',
        province: 430000,
        city: '',
        address: '',
        credentialValidStartDate: '',
        credentialValidExpireDate: '',
        credentialValidPeriod: '',
        credentialValidPeriodText: ''
      },
      formObjIndex: '',
      showIDTime: false,
      formObjPorps: '',
      showValidity: false,
      validityColumns: [
        { text: '5年', code: '5' },
        { text: '10年', code: '10' },
        { text: '20年', code: '20' },
        { text: '长期', code: '00' }
      ],
      formRules: {
        credentialValidStartDate: [
          { required: true, message: '请选择证件起期' }
        ],
        credentialValidExpireDate: [
          { required: true, message: '请选择证件止期' },
          {
            validator: this.idDate,
            message: '证件有效期止期不能小于证件证件起期'
          },
          {
            validator: this.idDate2,
            message: '证件有效期止期不能小于当前日期'
          }
        ],
        credentialValidPeriod: [
          { required: true, message: '请选择证件有效期' },
          {
            validator: this.validity,
            message: '证件有效期与起止日期不匹配'
          }
        ],
        appntNameR: [
          { required: true, message: '请输入真实姓名' },
          {
            validator: this.appCNNameValidator,
            message: '姓名由中文构成，2-20个汉字'
          },
          {
            validator: this.appENNameValidator,
            message: '姓名只能由中文或英文构成'
          }
        ],
        appntCardNoR: [
          { required: true, message: '请输入证件号' },
          { validator: this.appntIdNoValidator, message: '证件号格式不正确' }
        ],
        appntMobileNumber: [
          { required: true, message: '请输入手机号' },
          {
            validator: this.mobileNumberValidator,
            message: '手机号格式不正确'
          }
        ],
        appntSexR: [{ required: true, message: '请选择性别' }],
        userNameR: [
          { required: true, message: '请输入真实姓名' },
          {
            validator: this.userCNNameValidator,
            message: '姓名由中文构成，2-20个汉字'
          },
          {
            validator: this.userENNameValidator,
            message: '姓名只能由中文或英文构成'
          }
        ],
        userCardNoR: [
          { required: true, message: '请输入证件号' },
          { validator: this.userIdNoValidator, message: '证件号格式不正确' },
          { validator: this.repeatIdNoValidator, message: '证件号码重复' },
          {
            validator: this.spouseGender,
            message: '关系为配偶时,性别不能一致'
          }
        ],
        userSexR: [
          { required: true, message: '请选择性别' },
          {
            validator: this.spousevalidate,
            message: '关系为配偶时,性别不能一致'
          }
        ],
        userBirthday: [{ required: true, message: '请选择出生日期' }],
        userCanBaodi: [{ required: true, message: '请选择医保所属地' }]
      },
      DeviceInfo: {}, // 环境信息
      cityList: [], // 医保所属地列表
      activeIndex: null, // 着色索引
      firstClick: 1,
      showZdtbxy: false,
      contenthtml: '',
      noticesData: [{ label: '自动投保服务协议', code: 'ZDTBFW' }]
    }
  },
  computed: {},
  async created() {
    this.DeviceInfo = getDeviceInfo()
    this.getCityList()
    this.mobilePhone = SetGetAuthInfo.getInfo().mobilePhone
    if (this.DeviceInfo.env === 'wechat') {
      if (this.$route.query.insuranceId) {
        this.FindUserInsuranceDetail()
      } else {
        this.findUserInfo()
      }
    }
    let sourceCode = gethttpurl('fromSourceCode')
    let codeList = ['yxhb00000273']
    if (codeList.includes(sourceCode)) {
      this.formData.isAdvancePayment = '20'
      this.showAdvancePayment = false
    }
    switch (sourceCode) {
      case 'yxhb00000270':
        // 对接诸事达
        this.getZSDInfo()
        break
      case 'yxhb00000264':
        // 我的长沙
        this.getMYCS()
        break
      case 'yxhb00000272':
        // 对接老来网
        this.getLLWInfo()
        break
      case 'yxhb00000211':
        // 对接支付宝
        // this.getALIInfo()
        break
      default:
        break
    }
  },
  mounted() {
    this.userInfo.push(deepCopy(this.formObj))
    this.$nextTick(() => {
      this.getActive('oneself', 0)
    })
    this.$emit('getPeopleNumber', this.userInfo)
  },
  methods: {
    // 一键续保
    handleGoBuy() {
      this.historyForm.mobilePhone = ''
      this.historyForm.captcha = ''
      this.showCode = true
      this.sureDisabled = false
      this.loadingBuy = false
    },
    // 检测手机号
    checkPhone() {
      if (!this.historyForm.mobilePhone) {
        this.errMsg.mobilePhone = '请输入手机号！'
        return false
      } else if (!CHECK_MOBILE_PHONE(this.historyForm.mobilePhone)) {
        this.errMsg.mobilePhone = '手机号格式不正确！'
        return false
      } else {
        this.errMsg.mobilePhone = ''
        return true
      }
    },
    // 检测验证码
    checkVeriCode() {
      if (!this.historyForm.captcha) {
        this.errMsg.captcha = '请输入验证码！'
        return false
      }
      this.errMsg.captcha = ''
      return true
    },
    async handleBuy(type) {
      if (type == 1) {
        this.showCode = false
      } else if (type == 3) {
        this.showError = false
      } else {
        if (this.checkPhone() && this.checkVeriCode()) {
          this.handleSearchPerson()
        }
      }
    },
    // 再去 一键查询
    async handleSearchPerson() {
      const { mobilePhone, captcha } = this.historyForm
      this.loadingBuy = true
      this.sureDisabled = true
      try {
        const res = await FindUserRenewalInsure({
          applicantMobile: mobilePhone,
          captcha
        })
        const { insureds = [] } = res
        const {
          applicantMobile,
          applicantName,
          applicantCardNo,
          applicantCardType,
          applicantSex,
          applicantBirthday
        } = res.applicant
        // 购买人回显:如果不是身份证类型的,只保留名字和手机号
        if (applicantMobile) {
          this.formData.appntMobileNumber = applicantMobile
          this.formData.appntName = applicantName || ''
          if (applicantCardType == 'identityCard') {
            this.formData.appntIdNo = applicantCardNo || ''
          } else {
            this.formData.appntIdNo = ''
          }
          this.formData.appntName = applicantName
          this.formData.appntIdNo = applicantCardNo
          this.formData.appntMobileNumber = applicantMobile
          this.formData.appntIdType = applicantCardType
          this.formData.userSex = applicantSex
          this.formData.userBirthday = applicantBirthday
          if (applicantCardType != 'identityCard') {
            this.columns.map(citem => {
              if (citem.type == applicantCardType) {
                this.formData.idName = citem.text.slice(0, 3)
              }
            })
          }
          this.updateSelf()
          this.showCode = false
        }
        if (insureds.length > 0) {
          // 参保人回显
          this.showCode = false
          this.xuShow = false
          this.userInfo = []
          insureds.map(item => {
            let formObj = deepCopy(this.formObj)
            for (const key in formObj) {
              if (Object.hasOwnProperty.call(formObj, key)) {
                if (key == 'userMobile') {
                  item.userMobile = applicantMobile
                }
                if (key == 'userBirthday') {
                  formObj[key] = item[key]
                    ? item[key].split(' ')[0]
                    : formObj[key]
                } else {
                  formObj[key] = item[key] ? item[key] : formObj[key]
                }
                if (item.userCardType != 'identityCard') {
                  this.columns.map(citem => {
                    if (citem.type == item.userCardType) {
                      formObj.idName = citem.text.slice(0, 3)
                    }
                  })
                }
              }
            }
            this.userInfo.push(formObj)
          })
        }
        // 如果购买人和参保人都为空,给弹窗提示
        if (insureds.length == 0 && applicantName == null) {
          this.showCode = false
          this.showError = true
          this.xuShow = true
        }
        this.$emit('getPeopleNumber', this.userInfo)
      } catch (error) {
        this.loadingBuy = false
        this.sureDisabled = false
      }
    },
    clickIDTime(index, porps) {
      if (porps == 'credentialValidStartDate') {
        this.minDates = new Date('1900/01/01')
        this.maxDates = new Date()
      } else {
        if (
          this.userInfo[this.formObjIndex].credentialValidPeriodText == '长期'
        ) {
          return
        }
        let today = new Date()
        let tomorrow = today.getTime() + 1000 * 60 * 60 * 24
        this.minDates = new Date(tomorrow)
        this.maxDates = new Date('2299/12/31')
      }
      this.formObjIndex = index
      this.formObjPorps = porps
      this.showIDTime = true
    },
    openValidity(index) {
      this.formObjIndex = index
      this.showValidity = true
    },
    validityConfirm(val) {
      this.userInfo[this.formObjIndex].credentialValidPeriod = val.code
      this.userInfo[this.formObjIndex].credentialValidPeriodText = val.text
      if (val.code == '00') {
        this.userInfo[this.formObjIndex].credentialValidExpireDate = '长期'
      } else {
        this.userInfo[this.formObjIndex].credentialValidExpireDate = ''
      }
      this.showValidity = false
    },
    async findUserInfo() {
      try {
        let res = await findUserInfo({
          openId: SetGetAuthInfo.getInfo().openId
        })
        this.formData.appntName = res.appntName
        this.formData.appntIdNo = res.appntIdNo
        this.formData.appntMobileNumber = this.mobilePhone
        let infoData = res.userInsureEntities.filter(
          item => item.personnelType == 'policyHolder'
        )[0]
        this.formData.appntIdType = infoData.userCardType
        this.formData.userSex = infoData.userSex
        this.formData.userBirthday = infoData.userBirthday.split(' ')[0]
        if (infoData.userCardType != 'identityCard') {
          this.columns.map(citem => {
            if (citem.type == infoData.userCardType) {
              this.formData.idName = citem.text.slice(0, 3)
            }
          })
        }
        this.updateSelf()
      } catch (e) {
        console.log(e)
      }
    },
    async FindUserInsuranceDetail() {
      try {
        let res = await FindUserInsuranceDetail({
          id: this.$route.query.insuranceId,
          appCodeId: AppCode
        })
        this.userInfo = []
        res.userInsureEntities.map(item => {
          if (item.personnelType == 'policyHolder') {
            this.formData.appntName = item.userName
            this.formData.appntIdNo = item.userCardNo
            this.formData.appntMobileNumber = this.mobilePhone
            this.formData.appntIdType = item.userCardType
            this.formData.userSex = item.userSex
            this.formData.userBirthday = item.userBirthday.split(' ')[0]
            if (item.userCardType != 'identityCard') {
              this.columns.map(citem => {
                if (citem.type == item.userCardType) {
                  this.formData.idName = citem.text.slice(0, 3)
                }
              })
            }
          } else {
            let formObj = deepCopy(this.formObj)
            for (const key in formObj) {
              if (Object.hasOwnProperty.call(formObj, key)) {
                if (key == 'userBirthday') {
                  formObj[key] = item[key]
                    ? item[key].split(' ')[0]
                    : formObj[key]
                } else {
                  formObj[key] = item[key] ? item[key] : formObj[key]
                }
                if (item.userCardType != 'identityCard') {
                  this.columns.map(citem => {
                    if (citem.type == item.userCardType) {
                      formObj.idName = citem.text.slice(0, 3)
                    }
                  })
                }
              }
            }
            this.userInfo.push(formObj)
          }
        })
        this.updateSelf()
        setTimeout(() => {
          if (document.getElementById('a')) {
            document.getElementById('a').scrollIntoView()
          }
        }, 1000)
      } catch (e) {
        console.log(e)
      }
    },
    // 诸事达获取授权code
    getZSDInfo() {
      this.$bridge.callHandler(
        'getAuthCode',
        {
          client_id:
            process.env.VUE_APP_BUILD_TARGET == 'prod'
              ? 'zsd145653099011493888'
              : 'zsd144209938913394688',
          scope: 'PUB_USER_INFO,PRI_PHONE,PRI_USER_INFO',
          state: ''
        },
        responseData => {
          let res = JSON.parse(responseData)
          this.getCustomerInfo(res.code)
        }
      )
    },
    // 诸事达回显信息
    async getCustomerInfo(code) {
      try {
        let data = {
          channel: 'yxhb00000270',
          clientId: 'zsd144209938913394688',
          clientCode: code
        }
        let res = await getCustomerInfo(data)
        this.formData.appntName = res.name || ''
        this.formData.appntIdNo = res.cardNo || ''
        this.formData.appntMobileNumber = res.phone || ''
        this.formData.appntIdType = res.cardType || 'identityCard'
        this.formData.userSex = res.gender || ''
        this.formData.userBirthday = res.birthday || ''
        this.updateSelf()
      } catch (e) {
        console.log(e)
      }
    },
    // 我的长沙app信息回显
    getMYCS() {
      let data = gethttpurl('clientCode')
      let res = JSON.parse(
        AES.decrypt(data, 'cc8d354a9a744bab9173b6e7eae4fe0b')
      )
      this.formData.appntName = res.name || ''
      this.formData.appntIdNo = res.certificate_id || ''
      this.formData.appntMobileNumber = res.phone || ''
    },
    // 老来网信息回显
    getLLWInfo() {
      this.formData.appntName = decodeURIComponent(gethttpurl('name')) || ''
      this.formData.appntIdNo = gethttpurl('cardNum') || ''
      this.formData.appntMobileNumber = gethttpurl('phone') || ''
    },
    // 支付宝信息回显
    getALIInfo() {
      console.log('进入支付宝')
      window.AP.getAuthCode(
        {
          appId: '2021003141654347',
          scopes: ['auth_user'],
          showErrorTip: true
        },
        function (res) {
          console.log('获取参数', res)
          let authCode = res.authCode
          getALIInfo({ authCode: authCode })
            .then(res => {
              console.log('rescontent', res)
              this.formData.appntName = res.userName || ''
              this.formData.appntIdNo = res.certNo || ''
              this.formData.appntMobileNumber = res.mobile || ''
            })
            .catch(e => {
              console.log('errcontent', e)
            })
        }
      )
    },
    async clickAuto() {
      const res = await axiosclause({
        goodsCode: 'HN22001',
        code: 'HN22001-ZDTB'
      })
      this.contenthtml = res.content
      this.showZdtbxy = true
    },
    // 聚焦去除校验
    clearValidate(e, name, index) {
      this.formObjIndex = index
      if (name != 'appntForm') {
        this.$refs[name][index].resetValidation(e)
      } else {
        this.$refs[name].resetValidation(e)
      }
    },
    // 获取医保所属地列表
    async getCityList() {
      const cityList = await getCities({
        code: 430000
      })
      const newCityLsit = []
      if (cityList && cityList.length) {
        cityList.map(item => {
          newCityLsit.push({
            name: item.cityName,
            ...item
          })
        })
      }
      this.cityList = newCityLsit
      // console.log('cityList', cityList);
    },
    // 打开医保所属地 dialog
    openCanbaodi(text, index) {
      if (text) {
        for (let index = 0; index < this.cityList.length; index++) {
          const element = this.cityList[index]
          if (element.cityName == text) {
            this.activeIndex = index
          }
        }
      }
      this.formObjIndex = index
      this.showCanBaodi = true
    },
    // 选择医保所属地
    handleSelectCity(item, index) {
      this.activeIndex = index
      // 回显文本
      const { cityName: address, cityCode: city } = item
      // 入参处理
      Object.assign(this.userInfo[this.formObjIndex], { city, address })
    },
    // 确定 选择医保所属地
    handleSureCity() {
      if (this.activeIndex === null) {
        Toast('请选择医保所属地')
        return
      }
      this.activeIndex = null
      this.showCanBaodi = false
    },
    // 根据身份证号自动带出出生年月
    getIdNo(e, type) {
      if (this.formData.appntIdType === 'identityCard') {
        if (type === 'formData') {
          this.formData.userSex = GET_GENDER_FROM_ID(e)
          this.formData.userBirthday =
            GET_BIRTHDAY_FROM_ID(e)[0] +
            '-' +
            GET_BIRTHDAY_FROM_ID(e)[1] +
            '-' +
            GET_BIRTHDAY_FROM_ID(e)[2]
        } else {
          this.formObj.userSex = GET_GENDER_FROM_ID(e)
          this.formObj.userBirthday =
            GET_BIRTHDAY_FROM_ID(e)[0] +
            '-' +
            GET_BIRTHDAY_FROM_ID(e)[1] +
            '-' +
            GET_BIRTHDAY_FROM_ID(e)[2]
        }
      }
    },
    getVal() {
      let obj = {
        data: this.formData,
        userInfo: this.userInfo
      }
      return obj
    },
    deleteInsured(index) {
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否要删除被保人',
          theme: 'round-button',
          confirmButtonText: '确认',
          confirmButtonColor: '#FF6E3D',
          cancelButtonText: '取消',
          cancelButtonColor: '#cdcdcd'
        })
        .then(() => {
          this.userInfo.splice(index, 1)
          this.$emit('getPeopleNumber', this.userInfo)
        })
    },
    async getActive(relation, index) {
      try {
        // 判断是已有本人、配偶
        let isHaveSelf = false
        let isHaveSpouse = false
        let parentsArr = []

        this.userInfo.forEach(item => {
          if (item.insuredRelation === 'oneself') {
            isHaveSelf = true
          }
          if (item.insuredRelation === 'spouse') {
            isHaveSpouse = true
          }
          if (item.insuredRelation === 'parent') {
            parentsArr.push('parent')
          }
        })
        if (isHaveSelf && relation === 'oneself') {
          this.$toast('参保人已有本人')
          return
        }
        if (isHaveSpouse && relation === 'spouse') {
          this.$toast('已选择过配偶')
          return
        }
        // 当前参保人关系
        this.userInfo[index].insuredRelation = relation
        // 重置购买人身份证号校验
        this.$refs.appntForm.resetValidation('appntIdNo')
        // 重置当前参保人身份证号校验
        this.$refs.userForm[index].resetValidation('userCardNo')
        // 非本人设置为空
        if (this.userInfo[index].insuredRelation !== 'oneself') {
          for (const key in this.formObj) {
            if (Object.hasOwnProperty.call(this.formObj, key)) {
              if (key != 'insuredRelation') {
                this.userInfo[index][key] = this.formObj[key]
              }
            }
          }
        } else {
          this.updateSelf()
        }
      } catch (error) {
        console.log(error)
      }
    },
    updateSelf() {
      this.userInfo.forEach(item => {
        if (item.insuredRelation == 'oneself') {
          item.userName = this.formData.appntName
          item.idName = this.formData.idName
          item.userCardType = this.formData.appntIdType
          item.userCardNo = this.formData.appntIdNo
          item.userBirthday = this.formData.userBirthday
          item.userSex = this.formData.userSex
          item.userMobile = this.formData.appntMobileNumber
        }
      })
    },
    getType() {
      this.show = true
    },
    getTypeShow(index) {
      if (this.userInfo[index].insuredRelation !== 'oneself') {
        this.typeShow = true
      }
      this.formObjIndex = index
    },
    onConfirm(e) {
      this.formData.idName = e.text.slice(0, 3)
      this.formData.appntIdType = e.type
      this.show = false
      this.$refs.appntForm.validate('appntName')
      this.$refs.appntForm.validate('appntIdNo')
      this.updateSelf()
    },
    onConfirm2(e) {
      this.userInfo[this.formObjIndex].idName = e.text.slice(0, 3)
      this.userInfo[this.formObjIndex].userCardType = e.type
      this.typeShow = false
      this.$refs.userForm[this.formObjIndex].validate('userName')
      this.$refs.userForm[this.formObjIndex].validate('userCardNo')
    },
    getXfz() {
      try {
        if (this.xfzIndex === 0) {
          this.xfzIndex = 1
          this.xfzShow = true
          throw 'false'
        }
      } catch (error) {
        return error
      }
    },
    async addInfo() {
      if (this.xfzIndex === 0) {
        this.xfzIndex = 1
        this.xfzShow = true
        return false
      }
      try {
        await this.$refs.appntForm.validate()
        if (this.userInfo.length > 0) {
          for (let index = 0; index < this.userInfo.length; index++) {
            this.formObjIndex = index
            await this.$refs.userForm[index].validate()
          }
        }
        this.userInfo.push(deepCopy(this.formObj))
        this.$emit('getPeopleNumber', this.userInfo)
      } catch (error) {
        console.log('error------>', error)
        this.$toast(error[0].message)
        if (
          error[0].name.includes('user') |
          error[0].name.includes('picker') |
          error[0].name.includes('insuredRelation')
        ) {
          this.$refs.userForm[this.formObjIndex].scrollToField(
            error[0].name,
            true
          )
        } else {
          this.$refs.appntForm.scrollToField(error[0].name, true)
        }
        this.$toast(error[0].message)
        let elem = document.getElementsByTagName('html')[0].scrollTop
          ? document.getElementsByTagName('html')[0]
          : document.getElementsByTagName('body')[0]
        elem.scrollTop = elem.scrollTop - 110
      }
    },
    idDate(val) {
      let data1 = new Date(val).getTime()
      let data2 = new Date(
        this.userInfo[this.formObjIndex].credentialValidStartDate
      ).getTime()
      if (data1 <= data2) {
        return false
      }
    },
    idDate2(val) {
      let data1 = new Date(val).getTime()
      let data2 = new Date().getTime()
      if (data1 <= data2) {
        return false
      }
    },
    validity(val) {
      let data = setCompareRegistrationTimeText(
        this.userInfo[this.formObjIndex].credentialValidStartDate,
        this.userInfo[this.formObjIndex].credentialValidExpireDate
      )
      if (
        (this.userInfo[this.formObjIndex].credentialValidExpireDate ==
          '长期' ||
          data.year > 20) &&
        val == '长期'
      ) {
        return true
      } else if (
        data.year + '年' == val &&
        data.month == 0 &&
        data.day == 0
      ) {
        return true
      } else {
        return false
      }
    },
    // 校验姓名规则为中文👌
    appCNNameValidator(val) {
      if (this.formData.idName === '身份证') {
        return CnNameValidate(HalfFullWidithCharactor.ToCDB(val))
      }
      return true
    },
    appENNameValidator(val) {
      if (this.formData.idName !== '身份证') {
        // return EnNameValidate(HalfFullWidithCharactor.ToCDB(val))
        // eslint-disable-next-line no-unreachable
        var reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
        if (!reg.test(val)) {
          return false
        }
      } else {
        return true
      }
    },
    appntIdNoValidator() {
      let bo = true
      if (this.formData.appntIdType === 'identityCard') {
        bo = CHECK_ID(this.formData.appntIdNo)
      }
      return bo
    },
    // 校验姓名规则为中文👌
    userCNNameValidator(val) {
      if (this.userInfo[this.formObjIndex].idName === '身份证') {
        return CnNameValidate(HalfFullWidithCharactor.ToCDB(val))
      }
      return true
    },
    userENNameValidator(val) {
      if (this.userInfo[this.formObjIndex].idName !== '身份证') {
        // eslint-disable-next-line no-unreachable
        var reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
        if (!reg.test(val)) {
          return false
        }
      } else {
        return true
      }
    },
    userIdNoValidator(val) {
      let bo = true
      if (this.userInfo[this.formObjIndex].userCardType === 'identityCard') {
        bo = CHECK_ID(val)
      }
      return bo
    },
    spouseGender(val) {
      let bo = true
      if (this.userInfo[this.formObjIndex].insuredRelation == 'spouse') {
        if (this.userInfo[this.formObjIndex].userCardType == 'identityCard') {
          bo = checkSpouseGender({
            appntId: this.formData.appntIdNo,
            insuredId: val
          })
        }
      }
      return bo
    },
    spousevalidate(val) {
      let bo = true
      if (this.userInfo[this.formObjIndex].insuredRelation == 'spouse') {
        if (this.formData.appntIdType == 'identityCard') {
          bo =
            val !=
            (parseInt(this.formData.appntIdNo.substr(16, 1)) % 2 == 1 ? 0 : 1)
        } else {
          bo = val != this.formData.userSex
        }
        return bo
      }
    },
    repeatIdNoValidator(val) {
      let bo = true
      if (this.userInfo.length > 0) {
        for (let i = 0; i < this.userInfo.length; i++) {
          if (this.userInfo[i].userCardNo === val && i != this.formObjIndex) {
            bo = false
          }
        }
      }
      return bo
    },
    isUserSex() {
      let bo = true
      for (let i = 0; this.userInfo.length; i++) {
        if (this.userInfo[i].insuredRelation === 'spouse') {
          if (this.formData.userSex === this.userInfo[i].userSex) {
            return false
          }
        }
      }
      return bo
    },
    // 手机号格式校验
    mobileNumberValidator(val) {
      return CHECK_MOBILE_PHONE(val)
    },
    clickBirthday() {
      this.showBirthdayFlag = true
    },
    clickBirthday2(index) {
      this.formObjIndex = index
      if (this.userInfo[this.formObjIndex].insuredRelation === 'oneself') {
        return
      }
      this.showBirthdayFlag2 = true
    },
    // 确定时间选择后的时间
    onConfirmBirthday(val) {
      const currentDate = dayjs(val).format('YYYY-MM-DD')
      this.formData.userBirthday = currentDate
      this.showBirthdayFlag = false
      this.updateSelf()
    },
    // 确定时间选择后的时间
    onConfirmBirthday2(val) {
      const currentDate = dayjs(val).format('YYYY-MM-DD')
      this.userInfo[this.formObjIndex].userBirthday = currentDate
      this.showBirthdayFlag2 = false
    },
    confirmIDTime(val) {
      const currentDate = dayjs(val).format('YYYY-MM-DD')
      this.userInfo[this.formObjIndex][this.formObjPorps] = currentDate
      this.showIDTime = false
      this.currentDate2 = new Date('1990/01/01')
    },
    ckradio(val) {
      if (this.isSINCard) {
        return
      } else {
        switch (val) {
          case '10':
            this.formData.isAdvancePayment = val
            if (this.firstClick == 1) {
              // this.clickAuto()
              this.firstClick = 2
            }
            break

          default:
            if (this.formData.isAdvancePayment != '20') {
              this.formData.isAdvancePayment = '20'
              // this.$dialog
              //   .confirm({
              //     title: '温馨提示',
              //     message: '建议开通自动提醒,以免错失下一年保障!',
              //     theme: 'round-button',
              //     confirmButtonText: '开通',
              //     confirmButtonColor: '#FF6E3D',
              //     cancelButtonText: '不开通',
              //     cancelButtonColor: '#cdcdcd'
              //   })
              //   .then(() => {
              //     this.formData.isAdvancePayment = '10'
              //     if (this.firstClick == 1) {
              //       // this.clickAuto()
              //       this.firstClick = 2
              //     }
              //   })
              //   .catch(() => {
              //     this.formData.isAdvancePayment = '20'
              //   })
            }
            break
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  padding: 0 px2rem(20);
  background: #ffffff;
  margin-top: xvw(40);

  .user_title {
    display: block;
    width: xvw(312);
    height: xvw(66);
    margin: 0 auto;
  }

  .header {
    color: #f53641;
    margin: xvw(20) 0;

    .num {
      display: inline-block;
      width: xvw(38);
      height: xvw(38);
      line-height: xvw(38);
      text-align: center;
      font-size: xvw(22);
      border-radius: 50%;
      background: #fff1f1;
      position: relative;
      top: xvw(-4);
    }

    .title {
      font-size: xvw(32);
      margin-left: px2rem(13);
      font-weight: 600;
    }

    .subtitle {
      font-size: xvw(22);
    }
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .userCardNo {
    padding: 0;
  }

  .renewal-css {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fffcf9;
    border-radius: 15px;
    border: 1px solid #ffd287;
    margin: 15px 0px;
    padding: 0 10px;

    p {
      font-size: 15px;
      font-weight: 500;
      color: #aa0000;
      line-height: 23px;
    }

    img {
      width: 28%;
    }
  }

  .perDialog {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 0 20px 0;
    text-align: center;

    .not-yet {
      padding: 30px 25px 0px 25px;

      img {
        width: 50%;
      }
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 19px;
    }

    .perBtn {
      margin-top: 30px;

      .van-button {
        width: 250px;
        height: 40px;
        font-size: 12px;
        margin: auto;
        background: linear-gradient(180deg, #da2f0a 0%, #a80000 100%);
        color: #fff;
      }
    }

    .field-input {
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      border-bottom: 1px solid #f1f3f8;
      padding-left: 5px;
      padding-right: 5px;

      &::after {
        content: '';
        border-bottom: 0;
      }

      :deep(input) {
        color: #333333;
      }

      :deep(.van-field__body) {
        .van-field__control {
          color: #555555;
          font-size: 12px;
        }
      }
    }

    .textContent {
      font-size: 12px;
      color: #666666;
      line-height: 22px;
      padding: 20px 30px;
      // text-align: center;
    }

    .form-content {
      margin: 20px;
    }

    .perBtngroup {
      display: flex;

      .cancel {
        background: #ffffff !important;
        color: #cccccc !important;
        border: 1px solid #cccc !important;
      }

      .van-button {
        width: 130px;
        height: 40px;
        font-size: 12px;
        margin: auto;
        background: linear-gradient(180deg, #da2f0a 0%, #a80000 100%);
        color: #fff;

        b {
          color: #fbe1b5;
        }
      }
    }

    :deep(.van-dialog__header) {
      width: 100%;
      height: 43px;
      line-height: 43px;
      font-size: 13px;
      padding-top: 0px;
      font-weight: 500;
      background: linear-gradient(180deg, #da2f0a 0%, #a80000 100%);
      color: #ffff;
    }
  }

  .form {
    background: #ffffff;
    box-shadow: 0px 0px xvw(40) 0px rgba(0, 0, 0, 0.2);
    border-radius: xvw(20);
    color: #333;
    padding: xvw(10);

    .certificates {
      display: flex;
      align-items: center;
      font-size: xvw(26);
      padding: 0px 16px;
      position: relative;

      &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }

      .certificates-label {
        width: 26vw;
        height: 100%;
        display: flex;
        margin-right: 8px;
        justify-content: space-between;

        span {
          display: inline-block;
          width: xvw(145);
          overflow: hidden;
        }
      }

      .input {
        width: 100%;
      }
    }
  }

  .card {
    margin-top: xvw(16);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .userForm {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px xvw(20) 0px rgba(0, 0, 0, 0.2);
      border-radius: xvw(30);
      background: url('~@/assets/img/insu_detail/title_top.png') no-repeat top left #fff;
      background-size: 100px;
      padding-bottom: xvw(10);
      margin-bottom: xvw(30);
      box-sizing: border-box;

      &:last-child {
        margin: 0;
      }

      .part-title {
        height: xvw(52);
        padding-left: xvw(60);
        color: #fff;
        font-size: xvw(28);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn-delete {
          background-image: linear-gradient(#ff8741, #f51d1b);
          color: #fff;
          font-size: xvw(24);
          padding: xvw(12) xvw(25);
          box-sizing: border-box;
          border-radius: 0 xvw(32) 0 0;
        }
      }

      .relationships {
        display: flex;
        justify-content: flex-start;

        div {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: xvw(30);
          position: relative;
          width: xvw(120);
          height: xvw(60);
          color: #999999;
          background: #f8f8f8;
          border-radius: 4px;
          margin-right: xvw(20);
        }

        .active {
          color: #f63d47;

          img {
            position: absolute;
            bottom: 0;
            right: 0;
            width: xvw(30);
            height: xvw(20);
          }
        }
      }

      .startEndDate {
        position: relative;
        display: flex;
        align-items: center;
        font-size: xvw(24);
        padding: 0 xvw(30);
        box-sizing: border-box;

        .title {
          flex-shrink: 0;
          color: #646566;
        }

        .van-field {
          width: 34%;
        }

        ::v-deep .van-cell::after {
          border-bottom: none !important;
        }
      }

      .startEndDate:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
  }

  .add {
    margin-top: xvw(32);

    img {
      width: 100%;
    }
  }

  // 选择器
  .select-type {
    width: 100%;
    position: fixed;
    z-index: 100000;
    bottom: 0;
    left: 0;
  }

  /deep/.van-overlay {
    z-index: 10000;
  }

  // 添加被保人信息
  .content {
    padding: 10px;
    position: relative;

    .colse {
      position: absolute;
      right: 0;
      top: 0;
      margin-right: 8px;
      margin-top: 5px;
    }

    .title {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 37px;
        height: 15px;
      }

      span {
        margin: 0 8px;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .fasongya_text {
      padding: 0 pxrem(30);
      font-size: pxrem(28);
      font-weight: 400;
      color: #555555;
      line-height: pxrem(42);
      letter-spacing: pxrem(1);
      text-align: justify;

      span {
        color: #5675f1;
        cursor: pointer;
      }
    }

    .tel {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      span {
        display: inline-block;
        border-radius: 8px;
        padding: 0px 6px;
        height: 20px;
        line-height: 20px;
        background: rgb(237, 237, 237);
        color: #999;
      }

      .blue {
        color: #4385fc;
      }
    }

    .codeback {
      margin-top: 20px;

      /deep/.van-password-input__item {
        background: rgb(240, 238, 238);
      }
    }

    .sub-title {
      padding-left: 30px;
      margin-top: 28px;
      position: relative;
      font-size: 16px;
      font-weight: 600;

      &::before {
        position: absolute;
        left: 0;
        top: 0;
        margin-top: -2px;
        margin-left: 13px;
        content: '*';
        font-size: 28px;
        color: #ff7108;
      }
    }

    .relationships {
      // padding: 0 20px;
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;

      div {
        font-size: xvw(32);
        position: relative;
        width: xvw(165);
        height: xvh(90);
        line-height: xvh(90);
        color: #999999;
        text-align: center;
        background: #f8f8f8;
        border-radius: 4px;
      }

      .active {
        color: #f63d47;

        img {
          position: absolute;
          bottom: 0;
          right: 0;
          width: xvw(43);
          height: xvw(33);
        }
      }
    }

    .pform {
      margin-top: 20px;
      color: #333;

      /deep/.van-field__label {
        margin-right: 22px;
        color: #333;
        width: px2rem(215);
        font-size: xvh(26);
      }

      .certificates {
        display: flex;
        align-items: center;
        font-size: xvh(26);
        padding: 0px 16px;
        position: relative;

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 16px;
          bottom: 0;
          left: 16px;
        }

        .certificates-label {
          width: px2rem(215);
          height: 100%;
          display: flex;
          margin-right: 6px;
          justify-content: space-between;

          span {
            display: inline-block;
            width: xvw(145);
            overflow: hidden;
          }
        }

        .input {
          width: 100%;
        }
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      margin-top: 40px;

      .button {
        width: xvw(650);
      }
    }
  }
}

.radio_style {
  padding: 0 px2rem(15, 375);
  margin: xvw(30) 0;
  font-size: px2rem(12, 375);
  height: px2rem(75, 375);
  box-shadow: 0px 0px 30px 0px rgba(33, 75, 159, 0.2);
  border-radius: 8px;

  .radio_tabs {
    display: flex;
    justify-content: center;

    // background: #fff;
    div:nth-of-type(1) {
      margin-right: 50px;
    }

    .active {
      position: relative;
      color: #fb2e49 !important;
      border: 1px solid #fb2e49 !important;

      &::before {
        content: '';
        font-weight: 600;
        position: absolute;
        right: 0;
        top: 0;
        width: px2rem(18, 375);
        height: px2rem(18, 375);
        text-align: center;
        line-height: px2rem(18, 375);
        background: #fb2e49;
        color: #fff;
        border-top-right-radius: px2rem(15);
        border-bottom-left-radius: px2rem(20);
      }
    }

    div {
      background: #fff;
      font-size: px2rem(14, 375);
      width: px2rem(150, 375);
      height: px2rem(44, 375);
      line-height: px2rem(44, 375);
      text-align: center;
      position: relative;
      border-radius: px2rem(20);
      border: 1px solid #888;
      color: #888;
      margin: px2rem(15, 375) 0;

      img {
        width: px2rem(14, 375);
        height: px2rem(14, 375);
        position: absolute;
        right: 0;
        top: 0;
        margin-right: px2rem(2, 375);
        margin-top: px2rem(2, 375);
      }

      .ckTip {
        position: absolute;
        top: xvw(-6);
        left: 0;
        width: xvw(70);
        height: xvw(72);
      }
    }

    .noactive {
      span {
        border-radius: px2rem(20);
        display: inline-block;
        width: 100%;
        height: 100%;
        background: #fff;
      }
    }
  }

  p {
    margin-top: px2rem(5, 375);
    font-size: px2rem(12, 375);
    color: #bfbfbf;
    line-height: px2rem(19, 375);
  }
}

.open_detail {
  padding: px2rem(20, 375) px2rem(15, 375);
  margin-top: xvw(30);
  width: 100%;
  background: #f4faff;
  border-radius: 8px;

  .open-xy {
    font-size: px2rem(14, 375);
    color: #555;

    span {
      color: #0f75d6;
    }
  }

  .first_kt {
    display: flex;
    align-items: flex-start;

    .openList {
      margin-left: px2rem(10, 375);

      .open_title {
        color: #0f75d6;
        font-size: px2rem(14, 375);
        font-weight: 600;
      }

      .open_con {
        margin-top: 8px;
        font-size: px2rem(14, 375);
        color: #7180a0;
        line-height: px2rem(19, 375);
        margin-bottom: 10px;
      }
    }
  }

  img {
    width: px2rem(14, 375);
    height: px2rem(14, 375);
  }
}

.check-part {
  width: 100%;
  margin: px2rem(10, 375) auto px2rem(10, 375);
  display: flex;
  align-items: center;
  padding: 0px;

  .check-lf-box {
    flex-basis: 2rem;
    flex-shrink: 0;
  }

  .check-text {
    color: #9a9a9a;
    font-size: px2rem(11, 375);
    margin-left: px2rem(5, 375);
    line-height: px2rem(17, 375);

    a {
      color: #5675f1;
    }
  }
}

/* 选择医保所属地 list */
.city-list {
  margin-top: xvw(20);
  display: flex;
  flex-wrap: wrap;
  padding: xvw(20);

  .city-item {
    padding: xvw(12) xvw(20);
    font-size: xvw(32);
    color: #999;
    background-color: #f8f8f8;
    margin-right: xvw(20);
    margin-bottom: xvw(20);
    border-radius: xvw(8);
  }

  .city-item-acitve {
    background-color: #f8474f;
    color: #fff;
  }
}

.btn-canbaodi {
  margin-top: 0 !important;
  margin-bottom: xvw(20);
}

.contentstyle {
  padding: xvw(20);
}

.autoBtn {
  width: 70%;
  margin: 0 auto;
  background: linear-gradient(180deg, #ffae6a 0%, #ff2323 100%, #8f514a 100%);
  color: #ffffff;
}
</style>
<style lang="less">
.toastcss {
  text-align: left;
}
</style>
